import moment from "moment";
import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import Button from "../../../components/buttons";
import { Modal } from "react-bootstrap";
import { DateInput } from "../../../components/forms/";
import { BasicToast } from "../../../components/toasts";
import useArchiveDebtors from "../hooks/useArchiveDebtors";


export const ArchiveDebtorsModal = ({
    confirmButtonLabel = "Archive Debtors",
    confirmButtonVariant = "success",
    handleArchiveDebtorsModalClose,
    handleArchiveDebtorsModalConfirm,
    show,
    reloadDebtorsFromDate,
    ...rest
}) => {

    const [theArchiveDate, setTheArchiveDate] = useState(moment().endOf('month').format("YYYY-MM-DD"));
    //TODO what should this be set to?
    const reloadDebtorsToDate = moment().endOf('month').format("YYYY-MM-DD");
    
    //console.log('in archive modal passed reloadDebtorsFromDate', reloadDebtorsFromDate);
    //console.log('in archive modal passed reloadDebtorsToDate', reloadDebtorsToDate);
    
    const { archiveDebtors } = useArchiveDebtors(theArchiveDate,reloadDebtorsFromDate,reloadDebtorsToDate);

    
    
    const onClose = () => {
        if (handleArchiveDebtorsModalClose && typeof handleArchiveDebtorsModalClose === "function") {
            handleArchiveDebtorsModalClose();
        }
    }

    const onConfirm = () => {
        //const archiveDate = theArchiveDate;
        //if (handleArchiveDebtorsModalConfirm && typeof handleArchiveDebtorsModalConfirm === "function") {
            //handleArchiveDebtorsModalConfirm(archiveDate);
        //}
        archiveDebtors(theArchiveDate,reloadDebtorsFromDate,reloadDebtorsToDate)
                    .then(
                        r => {
                            toast.custom((t) => <BasicToast
                                control={t}
                                //date={new Date()}
                                icon="fa-solid fa-comments-question-check"
                                title="Debtors"
                                message={`Debtors for ${theArchiveDate} archived`}
                            />);
                        },
                        e => toast.error(e?.data)
                    )
                    .finally(onClose);
    };

    //console.log('from modal',reloadDebtorsFromDate);
    
    return (
            <Modal size="sm" centered backdrop="static" show={show}>
                <Modal.Header>Archive Debtors</Modal.Header>
                <Modal.Body {...rest}>
                <div className="row mb-3">
                        <div className="col">
                            <DateInput
                                label="Archive Date"
                                value={theArchiveDate}
                                onBlur={(value) => setTheArchiveDate(value)}
                            />
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant={confirmButtonVariant} onClick={onConfirm}>{confirmButtonLabel}</Button>
                    <Button variant="light" onClick={onClose}>Cancel</Button>
                    
                </Modal.Footer>
            </Modal>
    );

};

export default ArchiveDebtorsModal;